<script>
import {
    ValidationObserver,
    ValidationProvider,
    localize,
    extend,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import ja from "vee-validate/dist/locale/ja";
import axios from "axios";

// ルール設定
for (let rule in rules) {
    extend(rule, rules[rule]);
}
// 日本語化
localize("ja", ja);

/**
 * Forgot Password component
 */
export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            email: "",
            tryingToReset: false,
            isResetError: false,
            error: "",
            status: "",
        };
    },
    mounted() {
        this.isResetError = !!this.error;
        this.tryingToReset = !!this.status;
    },
    props: {
    },
    methods: {
        async handleResetPassword(event) {
            event.preventDefault(); // デフォルトのフォーム送信を防止
            this.isResetError = false;
            this.tryingToReset = false;

            try {
                // APIリクエストを送信
                const response = await axios.post("/api/password/forgot", {
                    email: this.email,
                });

                // 成功時の処理
                this.tryingToReset = true;
                this.status = response.data.message; // サーバーからの成功メッセージを表示
                console.log("Password reset email sent:", response.data);
            } catch (error) {
                // エラーハンドリング
                this.isResetError = true;
                if (error.response && error.response.data && error.response.data.message) {
                    this.error = error.response.data.message;
                } else {
                    this.error = "パスワードリセット中にエラーが発生しました。";
                }
                console.error("Error during password reset:", error);
            }
        },
    },
};
</script>

<template>
    <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5 mt-5">
            <div class="card overflow-hidden mt-4">
                <div class="card-body pt-0">
                    <b-alert v-model="isResetError" class="mb-4 mt-3" variant="danger" dismissible>{{ error }}</b-alert>
                    <b-alert v-model="tryingToReset" class="mb-4 mt-3" variant="success" dismissible>{{ status }}</b-alert>
                    <h3 class="ps-2 pt-2 mt-4">Reset Password</h3>
                    <ValidationObserver v-slot="{ invalid }">
                        <form class="p-2 mt-3" @submit.prevent="handleResetPassword">
                            <b-form-group label="Email" label-for="email" class="mb-3">
                                <ValidationProvider name="Email" rules="required" v-slot="{ errors }">
                                    <b-form-input id="email" v-model="email" name="email" type="email"
                                        placeholder="Enter email" autocomplete="off"></b-form-input>
                                    <p class="text-danger">{{ errors[0] }}</p>
                                </ValidationProvider>
                            </b-form-group>
                            <div class="form-group row mb-0">
                                <div class="col-12 text-end">
                                    <button class="btn btn-primary w-md" type="submit"
                                        :disabled="invalid">Reset</button>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
                <!-- end card-body -->
            </div>
            <!-- end card -->
        </div>
        <div class="mt-4 text-center">
            <p>© {{ new Date().getFullYear() }} Avalon Technologies, Inc.</p>
        </div>
        <!-- end col -->
    </div>
</template>
